<template>
  <v-container v-if="!loading && !$store.state.practiceData.paused" id="dashboard" fluid tag="section">

    <template v-if="$route.hash !== '#tutorial'">
      <base-material-alert v-if="$store.state.newRelease" class="mx-1 elevation-1"
        color="white"
        dismissible
        icon="mdi-bell"
      >
        <span class="font-weight-bold grey--text text--darken-1 display-1">{{ $store.state.newRelease.id }} - {{ $store.state.newRelease.notes }}</span> <br>
        <span class="grey--text text--darken-1">Released {{ getTimestamp($store.state.newRelease.created.toDate()) }} - <v-btn color="primary" text x-small @click="refreshClient">Refresh Now</v-btn></span>
      </base-material-alert>
      <base-material-alert v-if="$store.state.showAlert" class="mx-1 elevation-1"
        color="white"
        dismissible persist
        icon="mdi-bell"
      >
        <span class="font-weight-bold grey--text text--darken-1 display-1">Welcome to version {{ $store.state.version }} of Billit Build  - <v-btn color="primary" text x-small @click="$store.commit('setAlert', false); $router.push('/changelog')">See What's New</v-btn></span>
      </base-material-alert>
    </template>


    <v-layout class="mt-8">
      <v-select
        dense outlined style="max-width: 408px;" :disabled="carriers.length < 1" v-if="$store.state.locations.length > 0"
        :items="$store.state.locations" :no-data-text="`No ${$store.getters.locL}s on record. Add one from the ${$store.getters.locU}s tab.`"
        class="mb-2 ml-1" v-model="location" hide-details
        :label="`Sort by ${$store.getters.locU}`" clearable
        item-text="name" item-value="id"
      ></v-select>
      <v-spacer></v-spacer>
      <v-btn to="/packages" v-if="$route.hash !== '#tutorial'" color="billit" class="font-weight-bold" height="35">Install Package</v-btn>
      <AddCarrier/>
    </v-layout>

    <v-row v-if="carriers.length > 0" class="mt-4">
      <v-col cols="12" lg="4" v-for="carrier in carriers" :key="carrier.id">
        <base-material-chart-card color="billit">
          <template v-slot:heading>
            <v-layout column fill-height justify-center align-center>
              <v-icon x-large>mdi-package-variant</v-icon>
              <span class="caption font-weight-medium mt-1">Insurance Carrier</span>
            </v-layout>
            <CarrierPreferences :carrier="carrier"/>
          </template>
          <h4 class="card-title text-center font-weight-light mt-2 ml-2">{{ carrier.name }}</h4>
          <p
            class="text-center font-weight-light ml-2 mt-1"
          >Choices your frontdesk will see under this carrier</p>
          <p class="text-center red--text font-weight-light ml-2 mt-1" v-if="$getIncompleteNodeCount(carrier.choices) > 0 && carrier.isPackage">You have {{ $getIncompleteNodeCount(carrier.choices) }} incomplete instruction{{ $getIncompleteNodeCount(carrier.choices) === 1 ? '' : 's' }}</p>
          
          <!-- prod todo: put virtual scroller here when performance becomes a problem https://vuetifyjs.com/en/components/virtual-scrollers/ -->
          <div style="max-height: 300px; overflow-y: auto;">
            <!-- @click="isEndpoint = false; currentItem = item; currentCarrier = carrier; addChildDialog = true" -->
            <v-list class="pa-0" shaped dense light>
              <v-menu offset-y transition="slide-x-transition">
                <template v-slot:activator="{ on }">
                  <v-list-item style="padding-left: 10px;" v-on="on">
                    <v-icon>mdi-menu-right</v-icon>
                    <v-list-item-icon class="ml-2 mr-1"><v-icon>mdi-plus</v-icon></v-list-item-icon>
                    <v-list-item-title class="body-1 font-weight-light">Add Top-level Item</v-list-item-title>
                  </v-list-item>
                </template>
                <v-list dense>
                  <v-list-item @click="isEndpoint = false; isRedirect = false; rootLevel = true; addChildGlance = carrier.glanceTemplate; currentCarrier = carrier; addChildDialog = true">
                    <v-list-item-icon class="ml-1 mr-2"><v-icon>mdi-filter-variant-plus</v-icon></v-list-item-icon>
                    <v-list-item-title>Add Step</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="isEndpoint = true; isRedirect = false; rootLevel = true; addChildGlance = carrier.glanceTemplate; currentCarrier = carrier; addChildDialog = true">
                    <v-list-item-icon class="ml-1 mr-2"><v-icon>mdi-sticker-plus-outline</v-icon></v-list-item-icon>
                    <v-list-item-title>Make Instruction</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="isEndpoint = true; isRedirect = true; rootLevel = true; currentCarrier = carrier; addChildDialog = true">
                    <v-list-item-icon class="ml-1 mr-2"><v-icon>mdi-transfer-right</v-icon></v-list-item-icon>
                    <v-list-item-title>Make Redirect</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list>
            <v-treeview v-if="carrier.choices" class="body-1 font-weight-light" dense v-model="carrier.tree" :open="carrier.open" shaped hoverable open-on-click :items="carrier.choices">
              <template v-slot:prepend="{ item, open }">
                <v-icon v-if="!item.file">{{ open ? 'mdi-folder-open-outline' : 'mdi-folder-network-outline' }}</v-icon>
                <v-icon v-else>{{ files[item.file] }}</v-icon>
              </template>
              <template v-slot:label="{ item }">
                <span :title="item.name" :class="item.wysiwyg.replace(/\s/g,'') === $wysiwygStarter.replace(/\s/g,'') ? 'red--text' : null">{{ item.name }}</span>
              </template>
              <template v-slot:append="{ item }">
                <v-btn v-if="item.isEndpoint" :disabled="!item.wysiwyg" @click.stop="isEndpoint = true; isRedirect = false;  rootLevel = false; currentItem = item; currentCarrier = carrier; viewChildDialog = true" class="mr-0" icon>
                  <v-icon>mdi-eye-outline</v-icon>
                </v-btn>
                <v-menu v-else offset-y transition="slide-x-transition">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="mr-0" icon>
                      <v-icon>mdi-playlist-plus</v-icon>
                    </v-btn>
                  </template>
                  <!-- use item variable from slot:append to determine where the new child goes -->
                  <v-list dense>
                    <v-list-item @click="isEndpoint = false; isRedirect = false;  rootLevel = false; currentItem = item; addChildGlance = carrier.glanceTemplate; currentCarrier = carrier; addChildDialog = true">
                      <v-list-item-icon class="ml-1 mr-2"><v-icon>mdi-filter-variant-plus</v-icon></v-list-item-icon>
                      <v-list-item-title>Add Step</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="isEndpoint = true; isRedirect = false; rootLevel = false; currentItem = item; addChildGlance = carrier.glanceTemplate; currentCarrier = carrier; addChildDialog = true">
                      <v-list-item-icon class="ml-1 mr-2"><v-icon>mdi-sticker-plus-outline</v-icon></v-list-item-icon>
                      <v-list-item-title>Make Instruction</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="isEndpoint = true; isRedirect = true; rootLevel = true; currentCarrier = carrier; addChildDialog = true;">
                      <v-list-item-icon class="ml-1 mr-2"><v-icon>mdi-transfer-right</v-icon></v-list-item-icon>
                      <v-list-item-title>Make Redirect</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-btn @click.stop="currentCarrier = carrier; currentItem = item; editChildWysiwyg = item.wysiwyg; editChildSearchTerms = item.terms; editChildName = item.name; isEndpoint = item.isEndpoint; isRedirect = item.isRedirect || false; editChildRedirect = item.redirect; editChildGlance = item.glance; editChildDialog = true" class="mr-0" icon>
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
            </v-treeview>
          </div>
          <template v-slot:actions>
            <v-icon class="mr-2" small>mdi-clock-outline</v-icon>
            <span class="caption grey--text font-weight-light">{{ carrier.modified ? `Modified ${getTimestamp(carrier.modified.toDate())}` : `Added ${getTimestamp(carrier.created.toDate())}` }}</span>
          </template>
        </base-material-chart-card>
      </v-col>
    </v-row>
    <v-col align="center" class="py-12 mt-12" v-else>
      <v-icon size="104" color="grey">mdi-file-document-multiple-outline</v-icon>
      <p class="mt-8 display-1 font-weight-light" style="max-width: 40%;">
        <span v-if="$store.state.locations.length > 0"><span>You haven’t added any carriers under this {{ $store.getters.locL }} yet!</span> <br> <div class="my-2"></div> Start by either adding a custom carrier with the button on the top right, or by installing a <router-link to="/packages" class="primary--text text--darken-2" style="text-decoration: none;">package</router-link> under this {{ $store.getters.locL }}.</span>
        <span v-else>You don't have any carriers setup yet! <br> <div class="my-2"></div> <span v-if="$route.hash !== '#tutorial'">Start by either adding a custom carrier with the button on the top right, or by installing a <router-link to="/packages" class="primary--text text--darken-2" style="text-decoration: none;">package.</router-link> Additionally, setup <router-link :to="`/${$store.getters.locL}s`" class="primary--text text--darken-2" style="text-decoration: none;">{{ $store.getters.locL }}s</router-link> to make it simpler to manage a large amount of carriers.</span> <span v-else>The tutorial sidebar explains how to make one.</span></span>
      </p>
    </v-col>

    <v-dialog :persistent="addChildLoading || imageClicked" v-if="currentCarrier" v-model="addChildDialog" max-width="700">
      <v-card>
        <v-card-title>
          {{ isEndpoint ? (isRedirect ? 'Add a Redirect' : 'Add an Instruction') : (rootLevel ? 'Add Top-level Step' : 'Add a Step') }}
          <v-spacer />
          <v-icon aria-label="Close" @click="closeAddChildDialog">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="body-1 text-center">
          <v-form>
            <v-layout>
              <v-text-field
                outlined dense v-model="addChildName"
                label="Title" append-icon="mdi-format-font"
              ></v-text-field>              
            </v-layout>
            <template v-if="addChildRedirect">
              <p class="text-left mb-2 ml-2 font-weight-regular"><span class="caption font-weight-light">Redirects to:</span> <br> {{ constructNamePath(addChildRedirect.split('/').slice(-1)[0]) }}</p>
              <div class="text-left mb-4">
                <v-btn color="billit darken-3" small text @click="addChildRedirectDialog = false; redirectMatches = []; redirectSearchTerm = ''; addChildRedirect = ''">
                  Change
                  <v-icon small class="ml-2">mdi-transfer-right</v-icon>
                </v-btn>
              </div>
            </template>
            <!-- v show !addChildRedirect && !addChildRedirectDialog -->
            <div v-else-if="isRedirect" class="mb-8 mt-2 body-1 text-center">
              <v-text-field 
                outlined dense label="Search Keywords" @input="redirectSearch"
                v-model="redirectSearchTerm" persistent-hint clearable
                hint="Advanced search matches by predefined keywords set in the Dashboard."
              ></v-text-field>
              <v-layout column v-if="redirectMatches.length > 0">
                <div v-for="c in redirectMatches" :key="c.id">
                  <p class="text-left mt-4">{{ c.name }}</p>
                  <v-hover v-slot:default="{ hover }" v-for="(match, i) in c.nodes" :key="i">
                    <v-card @click.native="addChildRedirectDialog = false; redirectMatches = []; redirectSearchTerm = ''; addChildRedirect = match.toPath" :elevation="hover ? 4 : 0" style="cursor: pointer;" class="mb-4" outlined>
                      <v-card-title class="pt-2">{{ match.name }} <span v-if="match.isEndpoint">- Endpoint</span></v-card-title>
                      <v-card-text class="mt-2">
                        <v-layout column>
                          <v-icon v-if="match.isEndpoint" x-large color="grey" class="mb-2">mdi-file-outline</v-icon>
                          <v-icon v-else x-large color="grey" class="mb-2">mdi-folder-open-outline</v-icon>
                          <p class="font-weight-light"><span class="caption billit-underline">{{ match.namePath }}</span></p>
                          <span class="caption">Keywords: <span class="font-weight-light">{{ match.terms.join(', ') }}</span></span>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-hover>
                </div>
              </v-layout>
            </div>
            <div v-else>
              <tiptap-vuetify
                v-model="addChildWysiwyg"
                class="mb-5" style="border: 1px solid #9E9E9E; border-radius: 3px;"
                :card-props="{ flat: true, rounded: true }"
                :extensions="extensions"
              >
                <template v-slot:toolbar-after>
                  <v-divider></v-divider>
                </template>
              </tiptap-vuetify>
              <v-divider></v-divider>
              <v-subheader>Glance Bar - Set Yes/No values for quick information</v-subheader>
              <v-layout row wrap class="px-1 pb-4">
                <v-flex xs4 class="px-2">
                  <v-menu offset-x :close-on-content-click="false" v-model="addChildGlanceMenu" transition="slide-x-transition">
                    <template v-slot:activator="{ on }">
                      <GlanceBarCard add v-on="on" @click.native="addChildGlanceMenu = true" />
                    </template>
                    <v-layout column align-center class="white text-center pt-4 px-4">
                      <v-subheader class="mt-n5">Add Glance Card</v-subheader>
                      <v-text-field class="white" v-model="addChildAddGlanceTitle"
                        outlined dense hide-details style="max-width: 150px;"
                        label="Title" append-icon="mdi-format-font"
                      ></v-text-field>
                      <v-radio-group v-model="addChildAddGlanceEnabled" row>
                        <v-radio label="Yes" color="rgb(63, 228, 60)" :value="true"></v-radio>
                        <v-radio label="No" color="rgb(255, 76, 44)" :value="false"></v-radio>
                      </v-radio-group>
                      <v-btn
                        class="mb-3 mx-0 font-weight-medium" color="billit"
                        depressed block @click="addChildGlance.push({ title: addChildAddGlanceTitle, enabled: addChildAddGlanceEnabled, menu: false, }); addChildAddGlanceTitle = ''; addChildGlanceMenu = false"
                        height="30"
                      >Apply</v-btn>
                    </v-layout>
                  </v-menu>
                </v-flex>
                <v-flex xs4 class="px-2 mb-5" v-for="(item, i) in addChildGlance" :key="i">
                  <v-menu offset-x :close-on-content-click="false" v-model="item.menu" transition="slide-x-transition">
                    <template v-slot:activator="{ on }">
                      <GlanceBarCard :item="item" v-on="on" @click.native="item.menu = true" />
                    </template>
                    <v-layout column align-center class="white text-center pt-4 px-4">
                      <v-subheader class="mt-n5">Edit Glance Card</v-subheader>
                      <v-text-field class="white" v-model="item.title"
                        outlined dense hide-details style="max-width: 150px;"
                        label="Title" append-icon="mdi-format-font"
                      ></v-text-field>
                      <v-radio-group v-model="item.enabled" row>
                        <v-radio label="Yes" color="rgb(63, 228, 60)" :value="true"></v-radio>
                        <v-radio label="No" color="rgb(255, 76, 44)" :value="false"></v-radio>
                      </v-radio-group>
                      <v-btn
                        class="mb-3 mx-0 font-weight-medium" color="red"
                        depressed block @click="addChildGlance = addChildGlance.filter(g => g.title !== item.title); item.menu = false"
                        height="30" rounded outlined
                      >Remove</v-btn>
                    </v-layout>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-subheader>Search keywords to quickly find this item. Press enter to add a term.</v-subheader>
              <v-combobox
                v-model="addChildSearchTerms" outlined dense
                hide-selected :search-input.sync="addChildSearchTermsSync"
                deletable-chips label="Search Terms" multiple small-chips hide-no-data
              >
                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <v-chip
                    v-bind="attrs"
                    color="transparent"
                    :input-value="selected" label small
                  >
                    <span class="pr-2">
                      {{ item }}
                    </span>
                    <v-icon
                      small
                      @click="parent.selectItem(item)"
                    >mdi-close</v-icon>
                  </v-chip>
                </template>
              </v-combobox>
            </div>
            <v-divider class="mb-4"></v-divider>
            <!-- <v-text-field
              append-icon="mdi-lock-outline"
              type="password"
              outlined dense v-model="addChildAccessCode"
              label="Verify Access Code"
            ></v-text-field> -->
            <!-- <v-divider class="mb-4"></v-divider> -->
            <!-- v-dialog with Add Redirect button -->
            <v-dialog
              v-if="!isRedirect"
              v-model="addChildPreviewDialog" scrollable
              max-width="500px" fullscreen hide-overlay
              transition="dialog-bottom-transition"
            >
              <template v-slot:activator="{ on }">
                <v-layout class="pl-3" row>
                  <v-btn small outlined v-on="on" :disabled="(!addChildWysiwyg && !addChildGlance) || !!addChildRedirect" class="font-weight-medium" color="billit darken-1">Preview <v-icon class="ml-1" small>mdi-text-box-search-outline</v-icon></v-btn>
                </v-layout>
              </template>
              <v-card>
                <v-toolbar style="max-height: 50px;" color="billit" dense dark>
                  <v-icon size="large" class="mr-3">mdi-text-box-search-outline</v-icon>
                  <v-toolbar-title class="font-weight-medium"> {{ isEndpoint ? 'Preview Instruction' : 'Preview Step' }}</v-toolbar-title>
                  <v-spacer />
                  <v-icon size="28" aria-label="Close" @click="addChildPreviewDialog = false">mdi-close</v-icon>
                </v-toolbar>
                <v-layout row wrap justify-center align-center style="max-height: 200px;" class="mx-12 mt-6">
                  <v-flex xs2 class="px-2 mb-5" v-for="(item, i) in addChildGlance" :key="i">
                    <GlanceBarCard :item="item" display/>
                  </v-flex>
                </v-layout>
                <v-divider class="mb-4"></v-divider>
                <div
                  class="tiptap-vuetify-editor__content text-center"
                  v-html="addChildWysiwyg"
                />
              </v-card>
            </v-dialog>
          </v-form>
          <v-btn class="mt-3 font-weight-medium" color="billit" depressed
            default :loading="addChildLoading" rounded @click="addChild"
          >Save</v-btn>
          <p v-if="addChildFeedback" class="mt-5 red--text">{{ addChildFeedback }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <v-dialog :persistent="editChildLoading || imageClicked || deleteChildLoading" v-if="currentCarrier" v-model="editChildDialog" max-width="700">
      <v-card>
        <v-card-title>
          {{ isEndpoint ? (isRedirect ? 'Edit Redirect' : 'Edit Instruction') : (rootLevel ? 'Edit Top-level Step' : 'Edit Step') }}
          <v-spacer />
          <v-icon aria-label="Close" @click="closeEditChildDialog">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="body-1 text-center">
          <v-form>
            <v-layout>
              <v-text-field
                outlined dense v-model="editChildName"
                label="Title" append-icon="mdi-format-font"
              ></v-text-field>
            </v-layout>
            <template v-if="editChildRedirect">
              <p class="text-left mb-2 ml-2 font-weight-regular"><span class="caption font-weight-light">Redirects to:</span> <br> {{ constructNamePath(editChildRedirect.split('/').slice(-1)[0]) }}</p>
              <div class="text-left mb-4">
                <v-btn color="billit darken-3" small text @click="editChildRedirectDialog = false; redirectMatches = []; redirectSearchTerm = ''; editChildRedirect = ''">
                  Change
                  <v-icon small class="ml-2">mdi-transfer-right</v-icon>
                </v-btn>
              </div>
            </template>
            <!-- v show isRedirect -->
            <div v-else-if="isRedirect" class="mb-8 mt-2 body-1 text-center">
              <v-text-field 
                outlined dense label="Search Keywords" @input="redirectSearch"
                v-model="redirectSearchTerm" persistent-hint clearable
                hint="Advanced search matches by predefined keywords set in the Dashboard."
              ></v-text-field>
              <v-layout column v-if="redirectMatches.length > 0">
                <div v-for="c in redirectMatches" :key="c.id">
                  <p class="text-left mt-4">{{ c.name }}</p>
                  <v-hover v-slot:default="{ hover }" v-for="(match, i) in c.nodes" :key="i">
                    <v-card @click.native="editChildRedirectDialog = false; redirectMatches = []; redirectSearchTerm = ''; editChildRedirect = match.toPath" :elevation="hover ? 4 : 0" style="cursor: pointer;" class="mb-4" outlined>
                      <v-card-title class="pt-2">{{ match.name }} <span v-if="match.isEndpoint">- Endpoint</span></v-card-title>
                      <v-card-text class="mt-2">
                        <v-layout column>
                          <v-icon v-if="match.isEndpoint" x-large color="grey" class="mb-2">mdi-file-outline</v-icon>
                          <v-icon v-else x-large color="grey" class="mb-2">mdi-folder-open-outline</v-icon>
                          <p class="font-weight-light"><span class="caption billit-underline">{{ match.namePath }}</span></p>
                          <span class="caption">Keywords: <span class="font-weight-light">{{ match.terms.join(', ') }}</span></span>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-hover>
                </div>
              </v-layout>
            </div>
            <div v-else>
              <tiptap-vuetify
                v-model="editChildWysiwyg"
                class="mb-5" style="border: 1px solid #9E9E9E; border-radius: 3px;"
                :card-props="{ flat: true, rounded: true }"
                :extensions="extensions"
              >
                <template v-slot:toolbar-after>
                  <v-divider></v-divider>
                </template>
              </tiptap-vuetify>
              <v-divider></v-divider>
              <v-subheader>Glance Bar - Set Yes/No values for quick information</v-subheader>
              <v-layout row wrap class="px-1 pb-4">
                <v-flex xs4 class="px-2">
                  <v-menu offset-x :close-on-content-click="false" v-model="editChildGlanceMenu" transition="slide-x-transition">
                    <template v-slot:activator="{ on }">
                      <GlanceBarCard add v-on="on" @click.native="editChildGlanceMenu = true" />
                    </template>
                    <v-layout column align-center class="white text-center pt-4 px-4">
                      <v-subheader class="mt-n5">Add Glance Card</v-subheader>
                      <v-text-field class="white" v-model="editChildAddGlanceTitle"
                        outlined dense hide-details style="max-width: 150px;"
                        label="Title" append-icon="mdi-format-font"
                      ></v-text-field>
                      <v-radio-group v-model="editChildAddGlanceEnabled" row>
                        <v-radio label="Yes" color="rgb(63, 228, 60)" :value="true"></v-radio>
                        <v-radio label="No" color="rgb(255, 76, 44)" :value="false"></v-radio>
                      </v-radio-group>
                      <v-btn
                        class="mb-3 mx-0 font-weight-medium" color="billit"
                        depressed block @click="editChildGlance.push({ title: editChildAddGlanceTitle, enabled: editChildAddGlanceEnabled, menu: false, }); editChildAddGlanceTitle = ''; editChildGlanceMenu = false"
                        height="30"
                      >Apply</v-btn>
                    </v-layout>
                  </v-menu>
                </v-flex>
                <v-flex xs4 class="px-2 mb-5" v-for="(item, i) in editChildGlance" :key="i">
                  <v-menu offset-x :close-on-content-click="false" v-model="item.menu" transition="slide-x-transition">
                    <template v-slot:activator="{ on }">
                      <GlanceBarCard :item="item" v-on="on" @click.native="item.menu = true" />
                    </template>
                    <v-layout column align-center class="white text-center pt-4 px-4">
                      <v-subheader class="mt-n5">Edit Glance Card</v-subheader>
                      <v-text-field class="white" v-model="item.title"
                        outlined dense hide-details style="max-width: 150px;"
                        label="Title" append-icon="mdi-format-font"
                      ></v-text-field>
                      <v-radio-group v-model="item.enabled" row>
                        <v-radio label="Yes" color="rgb(63, 228, 60)" :value="true"></v-radio>
                        <v-radio label="No" color="rgb(255, 76, 44)" :value="false"></v-radio>
                      </v-radio-group>
                      <v-btn
                        class="mb-3 mx-0 font-weight-medium" color="red"
                        depressed block @click="editChildGlance = editChildGlance.filter(g => g.title !== item.title); item.menu = false"
                        height="30" rounded outlined
                      >Remove</v-btn>
                    </v-layout>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-subheader>Search keywords to quickly find this item. Press enter to add a term.</v-subheader>
              <v-combobox
                v-model="editChildSearchTerms" outlined dense
                hide-selected :search-input.sync="editChildSearchTermsSync"
                deletable-chips label="Search Terms" multiple small-chips hide-no-data
              >
                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <v-chip
                    v-bind="attrs"
                    color="transparent"
                    :input-value="selected" label small
                  >
                    <span class="pr-2">
                      {{ item }}
                    </span>
                    <v-icon
                      small
                      @click="parent.selectItem(item)"
                    >mdi-close</v-icon>
                  </v-chip>
                </template>
              </v-combobox>
            </div>
            <v-divider class="mb-4"></v-divider>
            <!-- <v-text-field
              append-icon="mdi-lock-outline"
              type="password"
              outlined dense v-model="editChildAccessCode"
              label="Verify Access Code"
            ></v-text-field> -->
            <!-- <v-divider class="mb-4"></v-divider> -->
            <v-layout row class="px-3">
              <v-dialog
                v-if="!isRedirect"
                v-model="editChildPreviewDialog" scrollable
                max-width="500px" fullscreen hide-overlay
                transition="dialog-bottom-transition"
              >
                <template v-slot:activator="{ on }">
                  <v-btn small outlined v-on="on" :disabled="(!editChildWysiwyg && editChildGlance && editChildGlance.length <= 0) || !!editChildRedirect" class="font-weight-medium" color="billit darken-1">Preview <v-icon class="ml-1" small>mdi-text-box-search-outline</v-icon></v-btn>
                </template>
                <v-card>
                  <v-toolbar style="max-height: 50px;" color="billit" dense dark>
                    <v-icon size="large" class="mr-3">mdi-text-box-search-outline</v-icon>
                    <v-toolbar-title class="font-weight-medium"> {{ isEndpoint ? 'Preview Instruction' : 'Preview Step' }}</v-toolbar-title>
                    <v-spacer />
                    <v-icon size="28" aria-label="Close" @click="editChildPreviewDialog = false">mdi-close</v-icon>
                  </v-toolbar>
                  <template v-if="editChildGlance.length > 0">
                    <v-layout row wrap justify-center align-center style="max-height: 200px;" class="mx-12 mt-6">
                      <v-flex xs2 class="px-2 mb-5" v-for="(item, i) in editChildGlance" :key="i">
                        <GlanceBarCard :item="item" display/>
                      </v-flex>
                    </v-layout>
                    <v-divider class="mb-4"></v-divider>
                  </template>
                  <div v-else class="my-6"></div>
                  <div
                    class="tiptap-vuetify-editor__content text-center"
                    v-html="editChildWysiwyg"
                  />
                </v-card>
              </v-dialog>
              <!-- class="font-weight-medium" intentionally unbolded -->
              <v-btn class="ml-3" v-if="currentItem && !isRedirect && (isEndpoint ? true : (!currentItem.children || currentItem.children.length === 0))" outlined small color="billit darken-1" @click="isEndpoint = !isEndpoint">Convert to {{ isEndpoint ? 'Step' : 'Instruction' }}</v-btn>
              <v-btn class="ml-3" :loading="deleteChildLoading" outlined small color="red darken-2" @click="deleteChild">Delete</v-btn>
            </v-layout>
          </v-form>
          <v-btn class="mt-6 font-weight-medium" color="billit" depressed
            default :loading="editChildLoading" :disabled="deleteChildLoading" rounded @click="editChild"
          >Save</v-btn>
          <p v-if="editChildFeedback" class="mt-5 red--text">{{ editChildFeedback }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-if="currentItem" v-model="viewChildDialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar style="max-height: 50px;" color="billit" dense dark>
          <v-icon size="large" class="mr-3">mdi-text-box-search-outline</v-icon>
          <v-toolbar-title class="font-weight-medium"> {{ isEndpoint ? 'View Instruction' : (rootLevel ? 'View Top-level Step' : 'View Step') }}</v-toolbar-title>
          <v-spacer />
          <v-icon size="28" aria-label="Close" @click="viewChildDialog = false">mdi-close</v-icon>
        </v-toolbar>
        <template v-if="currentItem.glance.length > 0">
          <v-layout row wrap justify-center align-center style="max-height: 200px;" class="mx-12 mt-6">
            <v-flex xs2 class="px-2 mb-5" v-for="(item, i) in currentItem.glance" :key="i">
              <GlanceBarCard :item="item" display/>
            </v-flex>
          </v-layout>
          <v-divider class="mb-4"></v-divider>
        </template>
        <div v-else class="my-6"></div>
        <div
          class="tiptap-vuetify-editor__content text-center"
          v-html="currentItem.wysiwyg"
        />
      </v-card>
    </v-dialog>



    <!-- redirect -->
    <v-dialog v-if="isEndpoint" v-model="addChildRedirectDialog" max-width="600" width="600">
      <!-- <template v-slot:activator="{ on }">
        <v-btn small outlined height="40" v-on="on" class="font-weight-medium ml-2" color="billit darken-1">Configure Redirect</v-btn>
      </template> -->
      <v-card style="width: 600px; overflow-x: hidden;">
        <v-card-title>
          Configure Redirect
          <v-spacer />
          <v-icon aria-label="Close" @click="addChildRedirectDialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="body-1 text-center">
          <v-text-field 
            outlined dense label="Search Keywords" @input="redirectSearch"
            class="mx-5" v-model="redirectSearchTerm" persistent-hint clearable
            hint="Advanced search matches by predefined keywords set in the Dashboard."
          ></v-text-field>
          <v-divider class="my-5"></v-divider>
          <v-layout column v-if="redirectMatches.length > 0">
            <div v-for="c in redirectMatches" :key="c.id">
              <p class="text-left mt-4">{{ c.name }}</p>
              <v-hover v-slot:default="{ hover }" v-for="(match, i) in c.nodes" :key="i">
                <v-card @click.native="addChildRedirectDialog = false; redirectMatches = []; redirectSearchTerm = ''; addChildRedirect = match.toPath" :elevation="hover ? 4 : 0" style="cursor: pointer;" class="mb-4" outlined>
                  <v-card-title class="pt-2">{{ match.name }} <span v-if="match.isEndpoint">- Endpoint</span></v-card-title>
                  <v-card-text class="mt-2">
                    <v-layout column>
                      <v-icon v-if="match.isEndpoint" x-large color="grey" class="mb-2">mdi-file-outline</v-icon>
                      <v-icon v-else x-large color="grey" class="mb-2">mdi-folder-open-outline</v-icon>
                      <p class="font-weight-light"><span class="caption billit-underline">{{ match.namePath }}</span></p>
                      <span class="caption">Keywords: <span class="font-weight-light">{{ match.terms.join(', ') }}</span></span>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-hover>
              <v-divider></v-divider>
            </div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- v-dialog with Configure Redirect button -->
    <v-dialog v-if="isEndpoint" v-model="editChildRedirectDialog" max-width="600" width="600">
      <!-- <template v-slot:activator="{ on }">
        <v-btn small outlined height="40" v-on="on" class="font-weight-medium ml-2" color="billit darken-1">Configure Redirect</v-btn>
      </template> -->
      <v-card style="width: 600px; overflow-x: hidden;">
        <v-card-title>
          Configure Redirect
          <v-spacer />
          <v-icon aria-label="Close" @click="editChildRedirectDialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="body-1 text-center">
          <v-text-field 
            outlined dense label="Search Keywords" @input="redirectSearch"
            class="mx-5" v-model="redirectSearchTerm" persistent-hint clearable
            hint="Advanced search matches by predefined keywords set in the Dashboard."
          ></v-text-field>
          <v-divider class="my-5"></v-divider>
          <v-layout column v-if="redirectMatches.length > 0">
            <div v-for="c in redirectMatches" :key="c.id">
              <p class="text-left mt-4">{{ c.name }}</p>
              <v-hover v-slot:default="{ hover }" v-for="(match, i) in c.nodes" :key="i">
                <v-card @click.native="editChildRedirectDialog = false; redirectMatches = []; redirectSearchTerm = ''; editChildRedirect = match.toPath" :elevation="hover ? 4 : 0" style="cursor: pointer;" class="mb-4" outlined>
                  <v-card-title class="pt-2">{{ match.name }} <span v-if="match.isEndpoint">- Endpoint</span></v-card-title>
                  <v-card-text class="mt-2">
                    <v-layout column>
                      <v-icon v-if="match.isEndpoint" x-large color="grey" class="mb-2">mdi-file-outline</v-icon>
                      <v-icon v-else x-large color="grey" class="mb-2">mdi-folder-open-outline</v-icon>
                      <p class="font-weight-light"><span class="caption billit-underline">{{ match.namePath }}</span></p>
                      <span class="caption">Keywords: <span class="font-weight-light">{{ match.terms.join(', ') }}</span></span>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-hover>
              <v-divider></v-divider>
            </div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
  <v-layout v-else-if="!loading && $store.state.practiceData.paused" fill-height column justify-center align-center>
    <p class="display-2 font-weight-regular">Your Billit subscription is currently paused.</p>
    <router-link class="display-1 mt-2 primary--text text--darken-1 font-weight-light" to="/account">Manage Account</router-link>
  </v-layout>
  <div v-else style="height: 100vh;"></div>
</template>

<script>
import moment from 'moment'
import { db, functions } from '@/firebase'
import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Image, Code, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule } from 'tiptap-vuetify'
import AddCarrier from '@/components/misc/AddCarrier'
import GlanceBarCard from '@/components/misc/GlanceBarCard'
import CarrierPreferences from '@/components/misc/CarrierPreferences'

export default {
  data() {
    return {
      location: null,
      loading: true,
      carriers: [],
      carriersList: [],
      currentItem: null,
      currentCarrier: null,
      isEndpoint: false,
      isRedirect: false,
      imageClicked: false,
      rootLevel: false,
      redirectSearchTerm: '',
      redirectMatches: [],
      addChildGlance: [],
      addChildGlanceMenu: false,
      addChildAddGlanceTitle: '',
      addChildAddGlanceEnabled: true,
      addChildRedirect: '',
      addChildRedirectDialog: false,
      // addChildAccessCode: '',
      addChildSearchTermsSync: null,
      addChildSearchTerms: ['Billit', 'Medical'],
      addChildName: '',
      addChildWysiwyg: '',
      addChildFeedback: false,
      addChildLoading: false,
      addChildDialog: false,
      addChildPreviewDialog: false,
      editChildPreviewDialog: false,
      editChildRedirect: '',
      editChildRedirectDialog: false,
      // editChildAccessCode: '',
      editChildSearchTermsSync: null,
      editChildSearchTerms: [],
      editChildName: '',
      editChildWysiwyg: ``,
      editChildFeedback: false,
      editChildGlance: [],
      editChildGlanceMenu: false,
      editChildAddGlanceTitle: '',
      editChildAddGlanceEnabled: true,
      editChildLoading: false,
      editChildDialog: false,
      deleteChildLoading: false,
      viewChildDialog: false,
      files: {
        redirect: "mdi-transfer-right",
        endpoint: "mdi-file-outline"
      },
      extensions: [
        Blockquote,
        Link,
        Bold,
        Underline,
        Italic,
        Strike,
        Code,
        ListItem,
        BulletList,
        // OrderedList,
        Image,
        [Heading, {
          options: {
            levels: [1, 2, 3]
          }
        }],
        HorizontalRule,
        HardBreak
      ],
    }
  },
  components: {
    AddCarrier, TiptapVuetify,
    CarrierPreferences, GlanceBarCard
  },
  watch: {
    carriersList(list) {
      if (!this.loading) {
        list.forEach(carrier => {
          carrier.tree = []
          carrier.open = []
        })
        this.carriers = list
      }
    },
    addChildSearchTerms (val) {
      if (val.length > 20) {
        this.$nextTick(() => this.addChildSearchTerms.pop())
      }
    },
    editChildSearchTerms (val) {
      if (val.length > 20) {
        this.$nextTick(() => this.editChildSearchTerms.pop())
      }
    },
  },
  mounted() {
    // setTimeout(() => {
    if (this.$route.hash === '#pricing' || this.$route.name === 'Pricing') this.$router.push('/account#pricing')
    // }, 300)
  },
  // the firestore: {} plugin ran too early and vue wasn't intiailized and this. was unavailable
  // so must use created hook 
  created() {
    this.addChildWysiwyg = this.$wysiwygStarter
    if (!this.$store.state.practiceData.paused) {
      this.$bind('carriersList', db.collection('carriers').where('userId', '==', this.$store.state.user.uid).orderBy('name', 'asc'))
      .then(() => {
        this.carriersList.forEach(carrier => {
          carrier.tree = []
          carrier.open = []
        })
        this.carriers = this.carriersList
        this.location = this.$store.state.locations[0]
        this.$watch('location', locationId => {
          if (!this.loading) {
            // carriers with locations of 'all' will show up regardless of chosen location
            if (locationId) {
              this.carriers = locationId ? this.carriersList.filter(carrier => carrier.locations !== 'all' ? carrier.locations.find(location => location.id === locationId) : true) : this.carriersList
            } else {
              this.carriers = this.carriersList
            }
          }
        })
        this.loading = false
      })
      this.$root.$on('wysiwygButtonClicked', options => {
        if (options.tooltip.text === 'Image') this.imageClicked = true
      })
    } else {
      this.loading = false
    }
  },
  methods: {
    constructNamePath(id) {
      let output
      let carriers = this.carriers
      carriers.forEach(carrier => {
        carrier.nodes = []
        carrier.choices.forEach((choice, i) => {
          let result = this.$getNodeNamePath(id, choice)
          if (result && result.node) {
            let namePath = []
            result.path.forEach(item => {
              namePath.push(item.name)
            })
            output = '/' + carrier.name + namePath.join('')
          }
        })
      })
      return output
    },
    redirectSearch(term) {
      if (term) {
        this.matches = []
        // this.$store.getters.carriers.forEach(carrier => choices.push(...carrier.choices))
        let carriers = this.carriers
        carriers.forEach(carrier => {
          carrier.nodes = []
          carrier.choices.forEach((choice, i) => {
            let result = this.$getNodeByKeyword(term, choice)
            // let result = {path: ['/'], node: choice}
            if (result && result.node) {
              let toPath = []
              let namePath = []
              result.path.forEach(item => {
                toPath.push(item.to)
                namePath.push(item.name)
              })
              result.node.toPath = '/' + carrier.id + toPath.join('')
              result.node.namePath = '/' + carrier.name + namePath.join('')
              carrier.nodes.push(result.node)
              if (!this.redirectMatches.find(c => c.id === carrier.id)) this.redirectMatches.push(carrier)
            }
          })
        })
      } else {
        this.redirectMatches = []
      }
    },
    getName(id, index) {
      let name
      let carriers = this.carriers
      
      if (index >= 2) {
        carriers.find(carrier => carrier.id === this.path[0]).choices.forEach((choice, i) => {
          let target = this.$getNodeById(id, choice)
          if (target) name = target.name
        })
      } else if (index === 1) {
        // console.log(id)
        name = carriers.find(carrier => carrier.id === this.path[0]).choices.find(rootChoice => rootChoice.id === id).name
      } else if (index === 0) {
        name = carriers.find(carrier => carrier.id === this.path[0]).name
      }
      if (!name) name = id
      return name
    },
    getTimestamp(timestamp) {
      return moment(timestamp).fromNow() 
    },
    refreshClient() {
      this.$store.commit('updateVersion')
      location.reload()
    },
    complete(index) {
      this.list[index] = !this.list[index]
    },
    addChild() {
      this.addChildFeedback = '',
      this.addChildLoading = true
      let f = functions.httpsCallable(this.rootLevel ? 'addRootChild' : 'addChild')
      const { addChildSearchTerms, addChildRedirect, addChildName, addChildWysiwyg, isEndpoint, isRedirect, currentItem } = this.$data
      f({ addChildSearchTerms, addChildRedirect, addChildName, addChildWysiwyg, isEndpoint, isRedirect, currentItem, carrierId: this.currentCarrier.id, glance: this.addChildGlance }).then(result => {
        // reset vars
        // this.addChildAccessCode = ''
        this.addChildRedirect = ''
        this.addChildSearchTerms = []
        this.addChildName = '',
        this.addChildGlance = []
        this.addChildWysiwyg = this.$wysiwygStarter,
        this.rootLevel = false
        this.addChildLoading = false
        this.closeAddChildDialog()
      })
      .catch(error => {
        this.addChildFeedback = error.message
        this.addChildLoading = false
      })
    },
    editChild() {
      this.editChildFeedback = '',
      this.editChildLoading = true
      let f = functions.httpsCallable('editChild')
      const { editChildSearchTerms, editChildRedirect, editChildName, editChildWysiwyg, isEndpoint, isRedirect, currentItem } = this.$data
      f({ editChildSearchTerms, editChildRedirect, editChildName, editChildWysiwyg, isEndpoint, isRedirect, currentItem, carrierId: this.currentCarrier.id, glance: this.editChildGlance }).then(result => {
        // reset vars
        // this.editChildAccessCode = ''
        // prod todo: // REFACTOR: put all these properties under one editChildItem: {}
        this.editChildSearchTerms = []
        this.editChildRedirect = ''
        this.editChildGlance = []
        this.editChildName = '',
        this.editChildWysiwyg = ``,
        this.editChildLoading = false
        this.closeEditChildDialog()
      })
      .catch(error => {
        this.editChildFeedback = error.message
        this.editChildLoading = false
      })
    },
    // delete is inside the edit, nvm
    deleteChild() {
      this.editChildFeedback = '',
      this.deleteChildLoading = true
      let f = functions.httpsCallable('deleteChild')
      const { currentItem } = this.$data
      f({currentItem, carrierId: this.currentCarrier.id}).then(result => {
        // reset vars
        // this.editChildAccessCode = ''
        this.deleteChildLoading = false
        this.closeEditChildDialog()
      })
      .catch(error => {
        this.editChildFeedback = error.message
        this.deleteChildLoading = false
      })
    },
    // wysiwyg library is broken, required to refresh page if image window is opened
    // otherwise styling breaks
    closeAddChildDialog() {
      this.addChildDialog = false
      if (this.imageClicked) location.reload()
    },
    closeEditChildDialog() {
      this.editChildDialog = false
      if (this.imageClicked) location.reload()
    },
  }
}
</script>


<style>
.billit {
  background-color: #55E6CC !important;
}
.v-application .info {
  background-color: #55E6CC !important;
  border-color: #55E6CC !important;
}

.tiptap-vuetify-editor__content p {
  margin-bottom: 20px !important;
}

.tiptap-vuetify-editor__content p:empty {
  margin-bottom: 30px !important;
}
</style>